// 重定向到sso登入url
export const GET_LOGIN_URL = 'GET_LOGIN_URL';
export const GET_ENV = 'GET_ENV';
export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_USER_PERMISSION = 'GET_USER_PERMISSION';
export const GET_SYSTEM_SETTINGS = 'GET_SYSTEM_SETTINGS';
export const GET_CATEGORY_TREE = 'GET_CATEGORY_TREE';
export const GET_USER_DISPLAY = 'GET_USER_DISPLAY';
export const GET_RG_ONCALL_VERSION = 'GET_RG_ONCALL_VERSION';
